import { Button } from "@mui/material"
import { trans } from "@/_providers/Translation"
import removeImage from "@/assets/img/reservations/icons/remove.svg"

export default function StorageStatusAutoCondition({
  transition,
  index,
  updateTransitionField,
  removeTransition,
  finalStatuses,
  initialStatuses,
  submitAttempted,
}) {
  return (
    <li key={transition.id} className="action-container">
      <div className="action-head">
        {trans("tables.activity")} {index + 1}
        <Button
          onClick={(e) => {
            e.stopPropagation()
            removeTransition(index)
          }}
        >
          <img src={removeImage} alt="Remove" />
        </Button>
      </div>
      <div className="action-body">
        <div className="row">
          <div className="col">
            <label>{trans("labels.reservationStartedWith")}</label>
            <span
              style={{
                backgroundColor:
                  initialStatuses.find(
                    (status) =>
                      Number(status.id) === Number(transition.initialStatusId),
                  )?.color || "#000",
              }}
            ></span>
            <select
              value={transition.initialStatusId || ''}
              onChange={(e) =>
                updateTransitionField(
                  index,
                  "initialStatusId",
                  e.target.value,
                )
              }
            >
              <option value="">-</option>
              {initialStatuses.map((status) => (
                <option key={status.id} value={status.id}>
                  {status.translation.name}
                </option>
              ))}
            </select>
          </div>
           <div className="col">
            <label>{trans("labels.reservationCompletedWith")}</label>
            <span
              style={{
                backgroundColor:
                  finalStatuses.find(
                    (status) =>
                      Number(status.id) === Number(transition.finalStatusId),
                  )?.color || "#000",
              }}
            ></span>
            <select
              value={transition.finalStatusId || ''}
              onChange={(e) =>
                updateTransitionField(
                  index,
                  "finalStatusId",
                  e.target.value,
                )
              }
              style={{
                borderColor: submitAttempted && !transition.finalStatusId ? '#ff6b6b' : 'inherit',
              }}
            >
              <option value="">-</option>
              {finalStatuses.map((status) => (
                <option key={status.id} value={status.id}>
                  {status.translation.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </li>
  )
}
